export default {
  //Romanian ro(languagecode) RO(countrycode) Romania / Romanian
  LandingPage: {
    intro_sub:
      'Oferă o a doua viață deșeurilor din ambalaje și participă la protejarea mediului.',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Alătură-te nouă în acțiunea de reducere a cantității de deșeuri',
    sequence1_2:
      'și ajută la protecția mediului prin transformarea ambalajului produs tău în obiecte utile. Derulează mai jos pentru a face primul pas.',
    sequence2_1: ' Îți prezentăm Samsung Upcycle-Packaging',
    sequence2_2:
      'O cutie pentru produs special concepută pentru a fi reciclată, aducându-ți contribuția ta la mediu. Realizează diverse obiecte de uz casnic cu ambalajul produs tău.',
    sequence3_1: 'Urmărește punctele tipărite pe ambalaj',
    sequence3_2:
      'Decupează ambalajul așa cum este indicat și asamblează-l, pentru a crea ceva nou și uimitor.',
    sequence4_1: 'Selectează obiectul pe care vrei să îl creezi',
    sequence4_2:
      'Derulează mai jos și selectează modelul produs pe care îl ai în pachet. Apoi, găsește diferite opțiuni de design pentru tine. Acum, începe călătoria cu obiectul pe care vrei să îl creezi.',
    selectBox: 'Selectează produs tău',
    moreActivity:
      "Pentru mai multe informații despre implicarea Samsung în activitățile de protejare a mediului",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitoare', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/ro/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/ro/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/ro/sustainability/overview/',
    footer: `
    Copyright© 2019-2021 Samsung. Toate drepturile rezervate.`,
  },
  ProductPage: {
    selectDesign: 'Selectează designul pentru a crea',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Consola TV',
    StorageBox: 'Cutie de depozitare',
    MagazineRack: 'Raft pentru reviste',
    CatHouse: 'Căsuță pentru pisici',
    CatTunnel: 'Tunel pentru pisici',
    BookShelf: 'Raft pentru cărți',
    DeskShelf: 'Raftul pentru birou',
    BlackRhino: 'Rinocer negru,\n specie pe cale\n de dispariție ', //update
    PolarBear: 'Ursul polar,\n specie pe cale de\n dispariție ', //update
    SeaTurtle: 'Țestoasa marină,\n specie pe cale de\n dispariție ', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Masă Kinoko', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Trusa de scule', //update
    DeskStationary: 'Papetărie',
    CoinBank: 'Pușculiță pentru monede',
    MobileScanner:'Suport pentru smartphone',
    TabletScanner:'Suport pentru tabletă',
    PetStairs:'Scări pentru animale de companie',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'mins',
    all:'ALL',
    in: 'în',
    inOnly: 'doar în',
    allBoxSize: 'Toate dimensiunile cutiei',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'instrucțiuni',
    prepare: 'Pregătește cutia',
    LetsDesign: "Să proiectăm",
    drawParts: 'Desenează părți ale cutiei',
    note1: 'Reține că poziția graficului poate varia în funcție de țări și de dimensiuni',
    note2: 'Schițează mai întâi întregul desen, astfel încât să se potrivească dimensiunii cutiei',
    numberSpace: 'număr = spații între puncte',
    diagonal: 'diagonală',
    LEFT: 'STÂNGA (parte)',
    RIGHT: 'DREAPTA (parte)',
    TOP: 'SUS (parte)',
    TOP1: 'SUS (parte) 1',
    TOP2: 'SUS (parte) 2',
    BACK: 'SPATE (parte)',
    MIDDLE: 'MIJLOC (parte)',
    MIDDLE2: 'MIJLOC (parte) 2',
    BOTTOM: 'BAZĂ (parte)',
    FRONT: 'FAȚĂ (parte)',
    SIDE: 'LATURĂ (parte)',
    secondSIDE: 'A DOUA LATURĂ (parte)',
    secondSIDE1: 'A DOUA LATURĂ (parte) 1',
    secondSIDE2: 'A DOUA LATURĂ (parte) 2',
    LEG: 'SUPORT (parte)', //update
    JOINT: 'ARTICULAȚIE (parte)', //update
    FACE: 'SUPRAFAȚĂ (parte)', //update
    DRAWERBOTTOM: 'BAZA SERTARULUI (parte)', //update
    DRAWERSIDE: 'LATERALA SERTARULUI (parte)', //update
    NOSE: 'PROTUBERANȚĂ (parte)', //update
    HANDLE: 'MÂNER (parte)', //update
    BOTTOMSIDE: 'PARTEA INFERIOARĂ (parte)', //update
    TOPSIDE: 'PARTEA SUPERIOARĂ (parte)', //update
    WING: 'CANAT (parte)', //update
    cutAndAssemble: "Să tăiem și să montăm",
    beCareful: 'Manevrează cu atenție instrumentul de tăiat, pentru a nu te răni',
    cutOutParts: 'Decupează părțile',
    assemble: 'Asamblează',
    Assemblyguide: 'Ghid pentru asamblare', //update
    fold: 'Exemplu de pliere',
    foldGuide: 'Folosește marginea mobilierului atunci când pliezi cartonul',
    foldGuideDezeen:
      'Apasă de câteva ori linia punctată de pe carton cu instrumentele de îndoire, pentru a ajuta cartonul să se plieze', //update
    glue: 'Aplică lipici sau bandă adezivă uniform pe suprafață', //update
    cable: 'Utilizează nailon sau sfoară pentru a lega', //update
    done: 'Am terminat!',
    goBack: 'Revino la meniul principal',
  },
  CautionPage: {
    CAUTION: 'ATENȚIE',
    needItem: 'Vei avea nevoie de aceste articole',
    children: 'Copiii nu trebuie să execute construcția decât în prezența și cu suportul adulților',
    mat:
      'Te rugăm să acoperi podeaua, pentru a preveni orice zgârieturi în timpul procesului de asamblare',
    doNotPutHeavyThing:
      'Nu călca sau sta pe aceste piese de mobilier și încearcă să nu pui lucruri grele pe ele',
    doNotThrow:
      'Nu arunca sau azvârli mobilierul spre nimic, inclusiv spre oameni și animale',
    stayAwayFlame: 'Depărtează-l de flăcări',
    stayAwayWater: 'Nu-l apropia de apă sau umiditate',
    mayDamaged: '* Cutia televizorului poate fi deteriorată în timpul procesului de expediere',
    companyDoestResponsible:
      '* Compania nu își asumă nicio responsabilitate pentru avarii sau vătămări în timpul acestei activități',
    cannotBeReturned:
      '* Produsul cu ambalaj deteriorat nu poate fi returnat ca având o problemă de calitate',
    understand: 'Bine, am înțeles',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Am folosit mai puțină hârtie și cerneală pentru majoritatea ambalajelor noastre pentru televizoare, în comparație cu ambalajele anterioare, pentru a ne intensifica angajamentul față de sustenabilitate',
      text2:'',
      text2_special:
        '(*Cele de mai sus nu se aplică anumitor modele, inclusiv televizoarelor Lifestyle)',
      text3: 'Selectează butoanele de mai jos, pentru a descoperi mai multe',
    },
    greenIn: {
      title: 'Going Green în sistemele de ambalare a televizoarelor',
      subtitle1: 'Caută informații despre produs',
      subtitle2: 'Reutilizarea Eco-Package',
      desc: 'Caută numele modelului pentru a obține mai multe informații',
      descM: '*Fă o fotografie cu numărul modelului TV',
      guide: 'numele modelului',
      button: 'Fă o fotografie',
      button2: 'Începe să creezi',
      product_info: 'Informațiile produsului',
    },
    search: {
      guide: 'Căutare..',
      noResult: 'Niciun rezultat',
      more: 'MAI MULT',
      search: 'Căutare',
      retake: 'Reluare',
      result: 'Rezultat',
    },
    photo: {
      guide1: 'Plasează numele modelului TV în casetă',
      guide2: '(ex: Q800A, UT7000, RU7100, etc)',
    },
  },
  searchCountrySelect: 'Selectează o țară pentru a căuta'
};
